class LicencePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'licence.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'licence._m';

    // Access suspended licences
    static ACCESS_SUSPENDED = 'licence.access.suspended';

    // Access shutdown licences
    static ACCESS_SHUTDOWN = 'licence.access.shutdown';

    // Create new manual licence for user
    static CREATE_USER = 'licence.create.user';

    // Create new manual licence for workspace
    static CREATE_WORKSPACE = 'licence.create.workspace';

    // Sync licences with subscription state
    static SYNC_SUBSCRIPTION = 'licence.sync.subscription';

    // Update licence info
    static UPDATE = 'licence.update';

    // Suspend / Resume licence
    static SUSPEND_MANAGE = 'licence.suspend.manage';

    // Shutdown licence
    static SHUTDOWN = 'licence.shutdown';
}

export default LicencePermission;
